import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Link from '../../Core/Link';

export const PredictiveSearchContainer = styled.ul`
  background-color: ${themeGet('colors.white')};
  box-shadow: 0 2px 16px 0 rgba(43, 44, 50, 0.28);
  width: 100%;
  max-width: 500px;
  z-index: 10;

  position: absolute;
  top: 115%;
  right: 0;

  &.centered-results {
    right: auto;
    left: 50%;
    transform: translateX(-50%);
  }

  li:not(:first-child) {
    margin-top: 0;
  }

  li {
    a,
    button {
      color: ${themeGet('colors.main-text')};
      font-size: 14px;
      font-weight: ${themeGet('fontWeights.bold')};
      font-stretch: normal;
      font-style: normal;
      line-height: 1.29;
      letter-spacing: normal;
      display: inline-block;
      text-align: left;
      width: 100%;
      padding: 9px 26px;

      &:focus,
      &:hover {
        background-color: ${themeGet('colors.light-grey')};
      }

      & > svg {
        display: none;
      }

      span {
        padding-bottom: 0;
        border-bottom: none;
        font-weight: inherit;
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    li {
      a,
      button {
        padding: 18px 26px;
      }
    }
  }
`;

export const SearchLink = styled(Link);
